export default {
  user: state => state.user,
  isAuthenticated: state => state.isAuthenticated,
  isGlobalAdmin: state =>
    state.user &&
    state.user.isAdmin &&
    state.user.region === '' &&
    state.user.zones === '',
  isRegionAdmin: state => state.user && state.user.isAdmin && state.user.region,
  isZoneAdmin: state => state.user && state.user.isAdmin && state.user.zones
}
